import { myAxios } from '@/services/myAxios';
import { defineStore } from 'pinia'

export const useWeatherCacheStore = defineStore('weatherCache', {
  state: () => ({
    pointWeather: {},
  }),
  actions: {
    async loadPointWeatherAsync(lat, lon, datetime) {
        const pointKey = `${lat.toFixed(6)},${lon.toFixed(6)}`;
        const existingRecord = this.pointWeather[pointKey];
        // datetime is sort of fized at a time of route calculation
        // but keep cache of 15 minutes in case date is manually changed
        const cacheDuration = 15 * 60; 

        if (existingRecord && existingRecord.expiry > datetime) {
            return existingRecord.data;
        }

        // use mwend endpoint on request from YZ 
        const URL = `https://mwend.bgeo.fi/api/v1/weather_info?lat=${lat}&lon=${lon}&t=${datetime}`

        try {
        const resp = await myAxios.get(URL)
            this.pointWeather[pointKey] = { expiry: datetime + cacheDuration, data: resp.data }
            return this.pointWeather[pointKey].data;
        } catch (error) {
            return { temperature: 'N/A', wind: 'N/A', windAngle: 'N/A' }
        }
    }
  },
  persist: false // weather cache is not persistent
})
